import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaArrowRight } from 'react-icons/fa'; 
// 1. IMPORT LINK FROM ROUTER
import { Link } from 'react-router-dom';
import './BrandIdentity.css';
import brandImage from '../../../../assets/ScrollComponents/img (1).png';

const BrandIdentity = () => {
  return (
    <section className="brand-identity-section">
      <Container className="h-100 d-flex flex-column justify-content-center">
        
        {/* --- MOBILE ONLY TITLE --- */}
        <div className="d-block d-lg-none pb-4">
            <h2 className="bi-heading mobile-heading">
                Branding   <br />and <br />DESIGNING
            </h2>
        </div>

        <Row className="h-100 flex-grow-1">
          
          {/* LEFT COLUMN: Text Content */}
          <Col lg={6} className="order-2 order-lg-1 d-flex flex-column justify-content-center py-3 py-lg-0">
            <div className="content-wrapper">
              
              {/* DESKTOP ONLY TITLE */}
              <h2 className="bi-heading d-none d-lg-block">
                Branding<br />
                and <br />
                DESIGNING
              </h2>
              
              <p className="bi-description">
                We help brands define who they are and how they’re perceived. From brand strategy to visual identity, we create systems that are consistent, scalable, and memorable across every touchpoint.
              </p>

              <div className="bi-link-wrapper mt-4 mt-lg-5">
                <div className="bi-divider"></div>
                {/* 2. CHANGE <a> TO <Link> and use 'to' prop */}
                <Link to="/contact" className="bi-link">
                  Learn more <FaArrowRight className="ms-3 arrow-icon" />
                </Link>
              </div>
            </div>
          </Col>

          {/* RIGHT COLUMN: Image */}
          <Col lg={6} className="order-1 order-lg-2 d-flex align-items-center justify-content-center h-100 py-3 py-lg-5">
            <div className="bi-image-wrapper " style={{backgroundColor:"#7A2B8F"}}>
              <img src={brandImage} alt="Brand Identity Mockup" className="bi-img" />
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default BrandIdentity;